/* istanbul ignore file */
// TODO [LEARN-15811]: ^ ignore coverage on this file until we can have app test scaffolding ready
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FlaggedRouteContentGetter as RouteContentGetter } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'
import { CurriculumRouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import withSiteContextLegacy from 'layers/content/v2/Hocs/withSiteContextLegacy'
import { navigationEvent } from 'layers/navigation/store/operations'
import withApiError from 'layers/errorHandling/apiError'
import { userSegmentationBuilder } from 'utils/userSegmentationHelpers'
import {
  AI_HS_PAGE_USAGE_KEY,
  sendApplicationInsightsEvent,
} from 'utils/sendAnalyticsDataHelpers'
import {
  resolveRouteServiceApp,
  isTier2PreviewMode,
  isDigitalWellBeingPreviewMode,
  isHighSchoolUrl,
  isK5Url,
  isMiddleSchoolUrl,
} from 'utils/routing/routeHelpers'
import { isPreviewMode } from 'utils/highschoolHelpers'
import { selectors as lmsSelectors } from 'store/lmsManager'
import { selectors as contextSelectors } from 'auth/stores/userContext'

import Component from './component'

const IndividualResourceContainer = props => {
  const {
    currentSite,
    routeContent,
    userSegmentationInfo,
    navigationEvent,
    productTabTitle,
    instructorData,
    userContext,
    match,
  } = props || {}
  const { content = {}, loading } = routeContent
  const { learningExperience } = content

  const readyToLoad = !!content && !loading

  useEffect(() => {
    sendApplicationInsightsEvent(AI_HS_PAGE_USAGE_KEY, userSegmentationInfo)
  }, [content])

  const isLessonPreview =
    isTier2PreviewMode() || isDigitalWellBeingPreviewMode()
  const isHsPreview = isPreviewMode() && isHighSchoolUrl()
  // isPreview is true if either preview mode is active
  const isPreview = isLessonPreview || isHsPreview

  return readyToLoad ? (
    <Component
      currentSite={currentSite}
      entry={learningExperience}
      gradeInstructorData={instructorData}
      isHsPreview={isHsPreview}
      isPreview={isPreview}
      match={match}
      navigationEvent={navigationEvent}
      productTabTitle={productTabTitle}
      routeContent={routeContent}
      userContext={userContext}
    />
  ) : null
}

IndividualResourceContainer.propTypes = {
  currentSite: PropTypes.shape({
    siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  instructorData: PropTypes.object,
  routeContent: PropTypes.shape({
    content: PropTypes.shape({
      learningExperience: PropTypes.object,
    }),
    loading: PropTypes.bool,
  }),
  userContext: PropTypes.object,
  userSegmentationInfo: PropTypes.object,
}

const mapStateToProps = (state, _) => {
  // Determine which instructor data to use based on the current URL
  let instructorData = null
  if (isHighSchoolUrl()) {
    instructorData = lmsSelectors.selectHsInstructorData(state)
  } else if (isMiddleSchoolUrl()) {
    instructorData = lmsSelectors.selectMiddleSchoolInstructorData(state)
  } else if (isK5Url()) {
    instructorData = lmsSelectors.selectk5InstructorData(state)
  }

  return {
    userSegmentationInfo: userSegmentationBuilder(state),
    productTabTitle: state.productManager?.productMap?.name || '',
    instructorData,
    userContext: contextSelectors.selectProgramContext(state),
  }
}

const mapDispatchToProps = {
  navigationEvent,
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

const HydratedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IndividualResourceContainer)

const siteContextOptions = { useGuard: true }

const CurriculumWrapped = withSiteContext(
  CurriculumRouteContentGetter(withApiError(HydratedComponent), options),
  siteContextOptions,
)
const LegacyWrapped = withSiteContextLegacy(
  RouteContentGetter(withApiError(HydratedComponent), options),
  siteContextOptions,
)

// High school lesson resources are fully migrated to curriculum-service.
// Elementary and middle school stay on the existing (flagged) legacy pipeline.
function IndividualResourceRouteContentGetter(props) {
  if (isHighSchoolUrl()) {
    return <CurriculumWrapped {...props} />
  }
  return <LegacyWrapped {...props} />
}

export default IndividualResourceRouteContentGetter
